import { useQueryClient } from '@tanstack/react-query';
import React from 'react';
import { GetCardContentQuery, GetCardLinksQuery, usePreloadCardsQuery } from '../../../../generated/core-api/graphql-react-query';
import useGlobalStoreContext from '../Contexts/GlobalStoreContext/useGlobalStoreContext';

export default function useCardPreload() {
  const { projectId: [projectId] } = useGlobalStoreContext();

  const cards = usePreloadCardsQuery(
    { input: { id: projectId ?? '' } },
    { enabled: !!projectId, cacheTime: 30 * 60 * 1000 },
  );
  const queryClient = useQueryClient();

  React.useEffect(() => {
    cards.data?.getProject.scopes.items.forEach((scope) => {
      const cardLinks: GetCardLinksQuery = {
        __typename: 'Query',
        getCardInstance: {
          __typename: 'CardScope',
          links: scope.links,
        },
      };
      const cardContent: GetCardContentQuery = {
        __typename: 'Query',
        getCard: scope.card,
      };
      queryClient.setQueryData(['getCardLinks', { cardId: scope.cardId, projectId }], cardLinks);
      queryClient.setQueryData(['getCardContent', { cardId: scope.cardId }], cardContent);
    });
  }, [cards.data, projectId, queryClient]);
}
